<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-shopping-basket"></i> Tebasan
                </div>
                <div class="card-tools mr-0">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                    <button v-if="$can('create tebasan')" type="button" class="btn btn-primary" @click="addNew">
                        <i class="fas fa-plus-square"></i> Tebasan
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/tebasans"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="status" slot-scope="props">
                            <span v-if="props.rowData.is_selesai" class="badge badge-pill badge-success">Selesai</span>
                            <span v-else class="badge badge-pill badge-warning">Proses</span>
                        </template>
                        <template slot="action" slot-scope="props">
                            <button type="button" title="View" @click="view(props.rowData)" class="btn btn-link px-1"><i class="fas fa-eye"></i></button>
                            <button v-if="$can('create tebasan') && isSameDay(props.rowData.created_at)" type="button" title="Edit" @click="edit(props.rowData)" class="btn btn-link px-1"><i class="fas fa-edit"></i></button>
                            <button v-if="$can('create tebasan') && !props.rowData.is_selesai" type="button" title="Penerimaan" @click="penerimaan(props.rowData)" class="btn btn-link px-1"><i class="fas fa-truck-loading"></i></button>
                            <button v-if="isSuperAdmin" type="button" title="Delete" @click="deleteItem(props.rowData)" class="btn btn-link px-1 text-danger"><i class="fas fa-trash-alt"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="editModal" size="md" :hide-header="true" :hide-footer="true">
            <edit-form :isEdit="isEdit" :value="currentTebasan" @saved="saved" @cancel="editModal = false"></edit-form>
		</b-modal>

        <b-modal v-model="viewModal" size="lg" :hide-header="true" :hide-footer="true">
            <viewer :value="currentTebasan" @saved="saved" @cancel="viewModal = false"></viewer>
		</b-modal>

        <b-modal v-model="penerimaanModal" size="md" :hide-header="true" :hide-footer="true">
            <penerimaan-form :tebasan-value="currentTebasan" @saved="saved" @cancel="penerimaanModal = false"></penerimaan-form>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import EditForm from './Form';
import SearchBar from './SearchBar';
import ExportMixin from '../../mixin/export';
import Viewer from './Viewer';
import PenerimaanForm from '../pembelian-tembakaus/Form';

export default {
    name: "tebasan",

    components: {
        EditForm,
        SearchBar,
        Viewer,
        PenerimaanForm,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentTebasan: null,
            searchText: '',
            searchDate: '',
            searchStatus: '',
            searchSupplierId: '',
            searchGradeId: '',
            viewModal: false,
            editModal: false,
            isEdit: false,
            penerimaanModal: false,
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'created_at',
                    title: 'Tanggal',
                    sortField: 'created_at',
                    callback: 'formatDate',
                },
                {
                    name: 'supplier.name',
                    title: 'Supplier',
                    sortField: 'supplier_name',
                },
                {
                    name: 'jumlah',
                    title: 'Jumlah (tanaman)',
                    sortField: 'jumlah',
                    callback: 'formatNumber',
                },
                {
                    name: 'harga',
                    title: 'Harga',
                    sortField: 'harga',
                    callback: 'formatNumber',
                },
                {
                    name: 'dp',
                    title: 'DP',
                    sortField: 'dp',
                    callback: 'formatNumber',
                },
                {
                    name: 'metode_pembayaran',
                    title: 'Metode',
                    sortField: 'metode_pembayaran',
                },
                {
                    name: '__slot:status',
                    title: 'Status',
                    sortField: 'is_selesai',
                },
                {
                    name: '__slot:action',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "created_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                status: this.searchStatus,
                supplier_id: this.searchSupplierId,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchStatus = search.searchStatus;
            this.searchSupplierId = search.searchSupplierId;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchStatus = '';
            this.searchSupplierId = '';
            this.refresh();
        },

        addNew() {
            this.isEdit = false;
            this.currentTebasan = null;
            this.editModal = true;
        },

        edit(rowData) {
            this.isEdit = true;
            this.currentTebasan = Object.assign({}, rowData);
            this.editModal = true;
        },

        penerimaan(rowData) {
            this.currentTebasan = Object.assign({}, rowData);
            this.penerimaanModal = true;
        },

        view(rowData) {
            this.currentTebasan = Object.assign({}, rowData);
            this.viewModal = true;
        },

        saved() {
            this.isEdit = false;
            this.currentTebasan = null;
            this.editModal = false;
            this.refresh();
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/tebasans/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        deleteItem(rowData) {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/tebasans/' + rowData.id,
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.isLoading = false;
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },
    },
}
</script>
